import { list as getList, show as getShow } from "~/api/contractHistory";
import * as types from "../mutation-types";
import store from "../../store";
import { clearableStore } from "~/mixins/clearableStore";

export const state = {
  list: null,
  meta: null,
  isLoading: false,
  entitiesData: {},
  typeData: {}
};

export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_HISTORY](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_HISTORY](state, contractStorage) {
    state.list = contractStorage;
  },
  [types.SET_CONTRACT_HISTORY_META](state, meta) {
    state.meta = meta;
  },
  [types.SET_CONTRACT_HISTORY_BY_ENTITY](state, { entityId, data }) {
    state.entitiesData = {
      ...state.entitiesData,
      [entityId]: {
        ...state.entitiesData[entityId],
        list: data
      }
    };
  },
  [types.SET_CONTRACT_HISTORY_META_BY_ENTITY](state, { entityId, meta }) {
    state.entitiesData = {
      ...state.entitiesData,
      [entityId]: {
        ...state.entitiesData[entityId],
        meta: meta
      }
    };
  },
  [types.SET_IS_LOADING_CONTRACT_HISTORY_BY_ENTITY](state, { entityId, status }) {
    state.entitiesData = {
      ...state.entitiesData,
      [entityId]: {
        ...state.entitiesData[entityId],
        isLoading: status
      }
    };
  },
  [types.SET_CONTRACT_HISTORY_BY_TYPES](state, { typeKey, data }) {
    state.typeData = {
      ...state.typeData,
      [typeKey]: {
        ...state.typeData[typeKey],
        list: data
      }
    };
  },
  [types.SET_CONTRACT_HISTORY_META_BY_TYPES](state, { typeKey, meta }) {
    state.typeData = {
      ...state.typeData,
      [typeKey]: {
        ...state.typeData[typeKey],
        meta: meta
      }
    };
  },
  [types.SET_IS_LOADING_CONTRACT_HISTORY_BY_TYPES](state, { typeKey, status }) {
    state.typeData = {
      ...state.typeData,
      [typeKey]: {
        ...state.typeData[typeKey],
        isLoading: status
      }
    };
  }
};

export const actions = {
  ...clearableStore.mutations,
  fetchContractHistories({ commit }, { contractId = null, params = null }) {
    commit(types.SET_IS_LOADING_CONTRACT_HISTORY, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId, params).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_HISTORY, data.data);
        commit(types.SET_CONTRACT_HISTORY_META, data.meta);
        commit(types.SET_IS_LOADING_CONTRACT_HISTORY, false);
      });
    }
  },
  fetchContractHistoryByEntity({ commit }, { contractId = null, entityId, params = null }) {
    commit(types.SET_IS_LOADING_CONTRACT_HISTORY_BY_ENTITY, { entityId, status: true });

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId && entityId) {
      getShow(activeContractId, entityId, params).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_HISTORY_BY_ENTITY, { entityId, data: data.data });
        commit(types.SET_CONTRACT_HISTORY_META_BY_ENTITY, { entityId, meta: data.meta });
        commit(types.SET_IS_LOADING_CONTRACT_HISTORY_BY_ENTITY, { entityId, status: false });
      });
    }
  },
  fetchContractHistoriesByTypes({ commit }, { contractId = null, params = null }) {
    if (!params?.typeIds || !Array.isArray(params.typeIds)) {
      return;
    }

    const typeKey = params.typeIds.sort().join(',');
    commit(types.SET_IS_LOADING_CONTRACT_HISTORY_BY_TYPES, { typeKey, status: true });

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId, params).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_HISTORY_BY_TYPES, { typeKey, data: data.data });
        commit(types.SET_CONTRACT_HISTORY_META_BY_TYPES, { typeKey, meta: data.meta });
        commit(types.SET_IS_LOADING_CONTRACT_HISTORY_BY_TYPES, { typeKey, status: false });
      });
    }
  }
};

export const getters = {
  list: (state) => state.list,
  meta: (state) => state.meta,
  isLoading: (state) => state.isLoading,
  getEntityData: (state) => (entityId) => state.entitiesData[entityId] || { list: null, meta: null, isLoading: false },
  getEntityList: (state) => (entityId) => state.entitiesData[entityId]?.list || null,
  getEntityMeta: (state) => (entityId) => state.entitiesData[entityId]?.meta || null,
  getEntityIsLoading: (state) => (entityId) => state.entitiesData[entityId]?.isLoading || false,
  hasEntityData: (state) => (entityId) => !!state.entitiesData[entityId],
  getTypeData: (state) => (typeIds) => {
    const typeKey = Array.isArray(typeIds) ? typeIds.sort().join(',') : typeIds;
    return state.typeData[typeKey] || { list: null, meta: null, isLoading: false };
  },
  getTypeList: (state) => (typeIds) => {
    const typeKey = Array.isArray(typeIds) ? typeIds.sort().join(',') : typeIds;
    return state.typeData[typeKey]?.list || null;
  },
  getTypeMeta: (state) => (typeIds) => {
    const typeKey = Array.isArray(typeIds) ? typeIds.sort().join(',') : typeIds;
    return state.typeData[typeKey]?.meta || null;
  },
  getTypeIsLoading: (state) => (typeIds) => {
    const typeKey = Array.isArray(typeIds) ? typeIds.sort().join(',') : typeIds;
    return state.typeData[typeKey]?.isLoading || false;
  },
  hasTypeData: (state) => (typeIds) => {
    const typeKey = Array.isArray(typeIds) ? typeIds.sort().join(',') : typeIds;
    return !!state.typeData[typeKey];
  }
};
